export const ClaimType = {
    HULL: "Hull",
    HULL_AND_LIABILITY: "Hull & Liability",
    LIABILITY: "Liability",
}